import { createSelector } from 'reselect'
import { RootState } from 'shared/stores'

export const financialMonitoringStateSelector = (state: RootState) => state.rp4.financialMonitoring

export const financialMonitoringLinksLoadingSelector = createSelector(financialMonitoringStateSelector, state => state.financialMonitoringLinksLoading)
export const financialMonitoringLinksSelector = createSelector(financialMonitoringStateSelector, state => state.financialMonitoringLinks)

export const toggleNavigation = createSelector(financialMonitoringStateSelector, state => state.showNavigation)
export const navSelectedKey = createSelector(financialMonitoringStateSelector, state => state.navigationSelectedKey)